var slideCollection = new Swiper('.slide-collection', {
    slidesPerView: 1.2, 
    spaceBetween: 16,

    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },

    breakpoints: { // 반응형 조건 속성 (on 객체 밖으로 이동)
        769: {
            slidesPerView: 3.2,
        },
        1024: {
            slidesPerView: 3,
        },
    },

});

